import PropTypes from 'prop-types';

export default (PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.number,
  category: PropTypes.number,
  entrances: PropTypes.arrayOf(PropTypes.object),
  divisions: PropTypes.object,
  recareas: PropTypes.arrayOf(PropTypes.string),
  components: PropTypes.shape({
    animal_list: PropTypes.bool,
    entry_exit_points: PropTypes.bool,
    group_with_fees_and_dates: PropTypes.bool,
    snowmobile: PropTypes.bool,
    watercraft_list: PropTypes.bool
  }),
  rules: PropTypes.array,
  travel_methods: PropTypes.array,
  validations: PropTypes.arrayOf(PropTypes.object)
}));
